import React from "react";
import { Box, Button, ButtonProps } from "@chakra-ui/react";
import { ChevronLeftIcon } from "./Icons";
import { useHistory } from "react-router-dom";

interface BackButtonProps extends ButtonProps {
  to: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  children,
  to,
  title,
  onClick,
  ...restProps
}) => {
  const history = useHistory();

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    if (onClick) {
      onClick(event);
    } else if (to) {
      history.push(to);
    }
  };

  return (
    <Button
      my={6}
      variant="ghost"
      textStyle="bodyRegular"
      fontWeight="400"
      px={0}
      onClick={handleClick}
      {...restProps}
      data-testid="back-button"
    >
      <ChevronLeftIcon boxSize="20px" />
      {title && <Box mr={2}>{title}</Box>}
      {children}
    </Button>
  );
};

export default BackButton;
